import React from "react";

function FeedbackThanks({
  showFeedbackThanks,
  setShowFeedbackThanks,
  showFeedback,
  setShowFeedback,
}) {
  return (
    <div
      className={
        showFeedbackThanks
          ? "absolute top-0 left-0 z-10 bg-[rgba(0,0,0,0.8)] w-full h-full  "
          : "hidden"
      }
    >
      <div className="flex justify-center items-center z-10 bg-[rgba(0,0,0,0.9)]  absolute top-[20%] left-[50%] transform -translate-x-1/2 font-semibold">
        <div className="w-[600px] text-[#2A5801] bg-white rounded-[10px] mx-[20px] px-[50px] py-[20px] mt-[30px] mb-[30px] pt-[40px] text-center ">
          <p>
            Thank you for your feedback! Your insights are invaluable in
            enhancing our app.
          </p>
          <p className="mt-[30px]  text-center">-Your voice matters!</p>
          <button
            id="doneBtn"
            onClick={() => setShowFeedbackThanks(false)}
            className="bg-[#295700] text-white rounded-[5px]  mt-[30px] px-[10px] py-[5px]"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}

export default FeedbackThanks;
